const PaymentChannelsBankLookupMode = {
  PaymentChannelForm: 'paymentChannelForm',
  AcceptPayorForm: 'acceptPayorForm',
  AcceptPayorOnboardingForm: 'acceptPayorOnboardingForm',
};
export { PaymentChannelsBankLookupMode };
